import * as React from 'react';
import { Outlet } from 'react-router-dom';

const Event: React.FC = () => {
  return <Outlet />;
};

export default Event;
